import React, {useState} from "react"
import {useSelector} from "react-redux"
import {Alert, Box, Tab, Tabs, Typography} from "@mui/material"
import {AI_TICKETS_ROLE} from "../../components/AiTickets/AiTicketsDrawer"
import {hermesGameToAiGame} from "../../components/AiTickets/aiTicketsUtils"
import GlossaryEditor from "./GlossaryEditor"
import TemplatesEditor from "./TemplatesEditor"
import KnowledgeEditor, {KnowledgeTabLabel} from "./KnowledgeEditor"

/**
 * Zendesk bot settings (ai-zendesk): game glossary, bot reply templates and knowledge from tickets. Left menu entry — admin_menu in containers/Main/*.js.
 * Same gating as the AI tickets panel: ai-zendesk is production-only, HERMES_SUPPORT role required.
 */
export default function AiZendeskSettings({game}) {
    const mode = useSelector((state) => state.data.SourceMode)
    const roles = useSelector((state) => state.data.UserSession?.user?.roles) ?? []
    const [tab, setTab] = useState("glossary")

    const allowed = mode?.isProd && roles.includes(AI_TICKETS_ROLE)

    return (
        <Box sx={{p: 3, maxWidth: 1200}}>
            <Typography variant="h5" gutterBottom>Zendesk bot</Typography>
            {!allowed ? (
                <Alert severity="info">
                    {mode?.isProd
                        ? `The ${AI_TICKETS_ROLE} role is required to edit the Zendesk bot settings.`
                        : "The Zendesk bot has only a production environment: switch Hermes to Production."}
                </Alert>
            ) : (
                <>
                    <Tabs value={tab} onChange={(_, value) => setTab(value)} sx={{mb: 2, borderBottom: 1, borderColor: "divider"}}>
                        <Tab value="glossary" label="Glossary"/>
                        <Tab value="templates" label="Reply templates"/>
                        <Tab value="knowledge" label={<KnowledgeTabLabel/>}/>
                    </Tabs>
                    {tab === "glossary" && <GlossaryEditor initialGame={hermesGameToAiGame(game) ?? "toh"}/>}
                    {tab === "templates" && <TemplatesEditor/>}
                    {tab === "knowledge" && <KnowledgeEditor initialGame={hermesGameToAiGame(game) ?? ""}/>}
                </>
            )}
        </Box>
    )
}
